import { useLocation } from 'react-router-dom'

export const useDatesFromUrl = () => {
    const { search } = useLocation()
    const searchParams = new URLSearchParams(search)

    const from = dateOpt(searchParams.get('from'))
    const to = dateOpt(searchParams.get('to'))

    return { from, to }
}

const dateOpt = (date: string | null): Date | null => {
    if (!date) {
        return null
    }

    const parts = date.split('-').map((item) => parseInt(item))
    if (parts.length !== 3) {
        return null
    }

    return new Date(parts[0], parts[1] - 1, parts[2])
}
